import { Link } from 'gatsby';
import React, { useState, useRef, useEffect } from 'react';
import uuid from 'uuid';

import './dropdown.scss';

const Dropdown = ({ activatorText, items = [], position = 'down' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const activatorRef = useRef();
  const listRef = useRef();

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = event => {
    if (listRef.current.contains(event.target) || activatorRef.current.contains(event.target)) {
      return;
    }

    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    // clean up on unmount
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div
      className="wrap"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      {position === 'top' && (
        <div
          ref={listRef}
          id={`list${uuid.v4()}`}
          className={`itemList` + (isOpen ? ' active' : '')}
        >
          {items.map((item, index) => (
            <div key={index}>
              <Link to={item.link} onClick={item.onClick} className="link">
                <strong>{item.name}</strong>
              </Link>
            </div>
          ))}
        </div>
      )}

      <span ref={activatorRef} className="activator" onClick={handleClick}>
        {activatorText + ''}
      </span>

      {position === 'down' && (
        <div
          ref={listRef}
          id={`list${uuid.v4()}`}
          className={`itemList` + (isOpen ? ' active' : '')}
        >
          {items.map((item, index) => (
            <div key={index}>
              <Link to={item.link} onClick={item.onClick} className="link">
                <strong>{item.name}</strong>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default Dropdown;
